import React, { useEffect } from "react";

export default function DeleteSuccess() {
  useEffect(() => {
    localStorage.removeItem("consumerAccessToken");
  localStorage.removeItem("consumerAccessTokenExpire");
  localStorage.removeItem("consumerRefreshToken");
  localStorage.removeItem("patientId");
  }, [])
  
  return (
    <div className="bg-primary text-white  px-6 py-8 relative sh-screen">
      {/* <button className="text-white absolute top-5 right-5 z-50" onClick={()=>navigate("/adminAccess")}>Admin</button> */}
      <img
        alt="human"
        src="../../../images/human21.png"
        className="w-72 absolute z-10 top-0 right-0 h-full"
      />
      <div className="z-20 relative  flex flex-col sm:w-3/5 mx-auto h-full">
        <div className="sm:flex sm:justify-center">
          <img
            alt="logo"
            src="../../../images/Logo.svg"
            className="mb-12 sm:mt-20"
          />
        </div>

        <div className=" text-3xl   w-full text-center flex h-full sm:h-auto justify-center items-center">
          <div className="flex max-w-xs w-full justify-center items-center border border-blue-400 rounded bg-white text-primary text-lg font-semibold shadow-md py-4 px-4">
            Your profile deleted successfully <br /> from our database
          </div>
        </div>
      </div>
    </div>
  );
}
